module.exports = __webpack_public_path__ + "src/assets/img/guy_left_2.a5197190.png";